import { api } from './client';

export const clientesTenantApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/clientes${qs ? `?${qs}` : ''}`);
  },
  obter: (id) => api.get(`/clientes/${id}`),
  criar: (dados) => api.post('/clientes', dados),
  atualizar: (id, dados) => api.put(`/clientes/${id}`, dados),
  remover: (id) => api.del(`/clientes/${id}`),
  obterContatos: (id) => api.get(`/clientes/${id}/contatos`),
  salvarContatos: (id, itens) => api.put(`/clientes/${id}/contatos`, { itens })
};
